module.exports = __webpack_public_path__ + "src/assets/img/customer-logos/curology.847e3bcdffd27cbc6ce4311f0878f9c7.png";